import { type RouteRecordRaw } from 'vue-router'

import { applyMetaToChildren } from '@/utils/router'

export const toolsRouter: RouteRecordRaw[] = [
  {
    children: applyMetaToChildren(
      [
        {
          component: async () => import('../views/SmsSubscriberToolView.vue'),
          meta: {
            title: 'tools.sms-subscriber-import',
          },
          name: 'brand.tools.sms-subscriber-import',
          path: 'sms-subscriber-import',
        },
        {
          component: async () => import('../views/DomainToolView.vue'),
          meta: {
            title: 'tools.dns',
          },
          name: 'brand.tools.dns',
          path: 'dns',
        },
        {
          component: async () => import('../views/CloneMenuView.vue'),
          meta: {
            title: 'tools.clone-menu',
          },
          name: 'brand.tools.clone-menu',
          path: 'clone-menu',
        },
        {
          component: async () => import('../views/DeleteLocationBrand.vue'),
          meta: {
            title: 'tools.delete-location-brand',
          },
          name: 'brand.tools.delete-location-brand',
          path: 'delete-location-brand',
        },
        {
          component: async () => import('../views/CreateHotLaunchToolView.vue'),
          meta: {
            title: 'tools.hot-launch',
          },
          name: 'brand.tools.hot-launch',
          path: 'hot-launch',
        },
        {
          component: async () => import('../views/OnboardingToolView.vue'),
          meta: {
            title: 'tools.onboarding',
          },
          name: 'brand.tools.onboarding',
          path: 'onboarding',
        },
        {
          component: async () => import('../views/ConversionCardsToolView.vue'),
          meta: {
            title: 'tools.conversion-cards',
          },
          name: 'brand.tools.conversion-cards',
          path: 'conversion-cards',
        },
        {
          component: async () =>
            import('../views/InStoreAppAdoptionMaterialsToolView.vue'),
          meta: {
            title: 'tools.in-store-app-adoption-materials',
          },
          name: 'brand.tools.in-store-app-adoption-materials',
          path: 'in-store-app-adoption-materials',
        },
        {
          beforeEnter: async (to, from, next) => {
            // Check if we have a single location brand
            const store = await import('@/store')
            const locations =
              store.default.getters['core/brand/active/locations']

            if (locations && locations.length === 1) {
              // Single location - redirect directly to the detail view
              return next({
                name: 'brand.tools.phone-tree.location',
                params: {
                  brandId: to.params.brandId,
                  locationId: locations[0].id,
                },
              })
            }

            // Multi-location or no locations - show the selector
            return next()
          },
          component: async () =>
            import('../views/PhoneTreeLocationSelectionView.vue'),
          meta: {
            title: 'tools.phone-tree-location-selection',
          },
          name: 'brand.tools.phone-tree',
          path: 'phone-tree',
        },
        {
          children: [
            {
              component: async () =>
                import(
                  '../components/phone-tree/management/PhoneTreeKeepNumberManagement.vue'
                ),
              meta: {
                title: 'tools.phone-tree.keep',
              },
              name: 'brand.tools.phone-tree.location.keep',
              path: 'keep',
              props: true,
            },
            {
              component: async () =>
                import(
                  '../components/phone-tree/management/PhoneTreeReplaceNumberManagement.vue'
                ),
              meta: {
                title: 'tools.phone-tree.replace',
              },
              name: 'brand.tools.phone-tree.location.replace',
              path: 'replace',
              props: true,
            },
          ],
          component: async () => import('../views/PhoneTreeView.vue'),
          meta: {
            title: 'tools.phone-tree',
          },
          name: 'brand.tools.phone-tree.location',
          path: 'phone-tree/location/:locationId',
          props: true,
        },
      ],
      {
        roles: ['pb:*'],
      }
    ),
    component: {
      name: 'OnboardingToolView',
      template: '<router-view />',
    },
    path: 'tools',
    redirect: { name: 'brand.tools.sms-subscriber-import' },
  },
]
